import {useEffect, useState} from 'react';
import * as yup from 'yup';
import {useTranslation} from 'react-i18next';
import {Modal} from 'react-bootstrap';
import {Formik} from 'formik';
import Select from 'react-select';
import {useSelector} from 'react-redux';
import InputGroup from '../../common/InputGroup';
import {newSelectWithBorder} from '../../common/shared/select.styled';
import Button from '../../common/Button';
import {NewSupplierPopUpStyled, PaymentDetailsModalStyled} from './expenses.styled';
import {Datepicker} from '../../common/Datepicker';
import { constants } from '../../common/constants/constants';
import BllinkUtils from '../../common/utils/utils';

export default function PaymentDetailModal({show, onHide, onSave, expenses = [], paymentMethods = [], bankOptions = [] }) {
    const {t} = useTranslation();
    const isLtrEnabled = useSelector(state => state.common.ltrEnabled);

    const [initialValues, setInitialValues] = useState({
        expenses: []
    });

    const validationSchema = yup.object().shape({
        expenses: yup.array()
            .of(
                yup.object().shape({
                    branchNum: yup.string().matches(/^\d+$/, t('titles.forms.number_field')),
                    accountNum: yup.string(),
                    bankCode: yup.object(),
                    paymentMethod: yup.object(),
                    chequeNumber: yup.number(),
                    date: yup.string(),
                    amount: yup.string().matches(/^-?\d+\.?\d*$/, t('titles.forms.number_field')).required(t('titles.forms.mandatory_field')),
                })
            )
    });

    useEffect(() => {
        if (expenses.length) {
            let expensesData = [];
            expenses.forEach(item => {
                expensesData = [
                    ...expensesData,
                    {
                        ...item,
                        bankCode: {},
                        paymentMethod: {},
                        branchNum: '',
                        accountNum: '',
                        chequeNum: '',
                        date: ''
                    }
                ];
            });
            setInitialValues({
                expenses: expensesData
            });
        }
    }, [expenses]);

    const renderForm = ({handleChange, handleBlur, setFieldValue, setFieldTouched, values, isValid, dirty, errors, touched}) => {
        return (
            <form>
                {
                    expenses.map((item, index) => {
                        return (
                            <div className='data-block' key={index}>
                                <div className='modal-row amount-row'>
                                    <InputGroup
                                        labelText={t('expenses.payment_method')}
                                        errorText={errors && touched && errors[index]?.paymentMethod && touched[index]?.paymentMethod ? errors[index]?.paymentMethod : ''}
                                        withBorder
                                    >
                                        <Select
                                            styles={newSelectWithBorder}
                                            options={paymentMethods || []}
                                            onChange={evt => setFieldValue(`expenses[${index}].paymentMethod`, evt)}
                                            onBlur={() => setFieldTouched(`expenses[${index}].paymentMethod`, true)}
                                            value={values[index].paymentMethod}
                                            isRtl={!isLtrEnabled}
                                        />
                                    </InputGroup>

                                    <InputGroup
                                        labelText={t('expenses.expense_record_table_amount')}
                                        errorText={errors && touched && errors[index]?.amount && touched[index]?.amount ? errors[index]?.amount : ''}
                                        withBorder
                                    >
                                        <input
                                            type="text"
                                            className={`form-control ${errors && touched && errors[index]?.amount && touched[index]?.amount ? 'error' : ''}`}
                                            name={`expenses[${index}].amount`}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values[index].amount}
                                        />
                                    </InputGroup>
                                </div>
                                <div className='modal-row'>
                                    <InputGroup
                                        labelText={t('offline_payments.bank_code_title')}
                                        errorText={errors && touched && errors[index]?.bankCode && touched[index]?.bankCode ? errors[index]?.bankCode : ''}
                                        withBorder
                                    >
                                        <Select
                                            styles={newSelectWithBorder}
                                            options={bankOptions || []}
                                            onChange={evt => setFieldValue(`expenses[${index}].bankCode`, evt)}
                                            onBlur={() => setFieldTouched(`expenses[${index}].bankCode`, true)}
                                            value={values[index].bankCode}
                                            isRtl={!isLtrEnabled}
                                        />
                                    </InputGroup>

                                    <InputGroup
                                        labelText={t('offline_payments.bank_branch_title')}
                                        errorText={errors && touched && errors[index]?.branchNum && touched[index]?.branchNum ? errors[index]?.branchNum : ''}
                                        withBorder
                                    >
                                        <input
                                            type="text"
                                            className={`form-control ${errors && touched && errors[index]?.branchNum && touched[index]?.branchNum ? 'error' : ''}`}
                                            name={`expenses[${index}].branchNum`}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values[index].branchNum}
                                        />
                                    </InputGroup>

                                    <InputGroup
                                        labelText={t('offline_payments.bank_account_number_title')}
                                        errorText={errors && touched && errors[index]?.accountNum && touched[index]?.accountNum ? errors[index]?.accountNum : ''}
                                        withBorder
                                    >
                                        <input
                                            type="text"
                                            className={`form-control ${errors && touched && errors[index]?.accountNum && touched[index]?.accountNum ? 'error' : ''}`}
                                            name={`expenses[${index}].accountNum`}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values[index].accountNum}
                                        />
                                    </InputGroup>

                                    {
                                        values[index].paymentMethod.value === constants.managerPaymentsOptions.cheque && (
                                            <InputGroup
                                                labelText={t('expenses.cheque_num')}
                                                errorText={errors && touched && errors[index]?.chequeNum && touched[index]?.chequeNum ? errors[index]?.chequeNum : ''}
                                                withBorder
                                            >
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors && touched && errors[index]?.chequeNum && touched[index]?.chequeNum ? 'error' : ''}`}
                                                    name={`expenses[${index}].chequeNum`}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values[index].chequeNum}
                                                />
                                            </InputGroup>

                                        )
                                    }

                                    <InputGroup
                                        labelText={t('offline_payments.date')}
                                        errorText={errors && touched && errors[index]?.date && touched[index]?.date ? errors[index]?.date : ''}
                                        withBorder
                                    >
                                        <Datepicker
                                            inputProps={{
                                                name: `expenses[${index}].date`
                                            }}
                                            placeholder={'dd/mm/yyyy'}
                                            defaultValue={new Date()}
                                            onDayChange={selectedDay => setFieldValue(`expenses[${index}].date`, selectedDay && selectedDay.toISOString())}
                                            onDayPickerHide={() => setFieldTouched(`expenses[${index}].date`, true)}
                                            styledContainerProps={{
                                                isNewDesign: true,
                                                isRtl: !isLtrEnabled,
                                                className: 'new-design'
                                            }}
                                        />
                                    </InputGroup>
                                </div>
                            </div>
                        )
                    })
                }

                <div className='modal-row'>
                    <Button
                        type={'button'}
                        rounded={false}
                        disabled={!isValid}
                        onClick={() => onSave(values)}
                    >
                        {t('reports.save')}
                    </Button>
                </div>
            </form>
        );
    }

    const totalAmount = BllinkUtils.Money.roundNumber(expenses.map((e) => parseFloat(e.amount)).reduce((a, b) => a + b, 0));

    return (
        <PaymentDetailsModalStyled
            className={'header-with-bg'}
            show={show}
            onHide={onHide}
            centered
        >
            <span
                className={'modal-close'}
                onClick={onHide}
            >
                &#215;
            </span>
            <Modal.Header>
                <Modal.Title className={'text-center'}>
                    {t('expenses.paymentDetails', {total: BllinkUtils.Strings.numberWithCommas(totalAmount)})}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                >
                    {({
                          errors,
                          touched,
                          values,
                          handleChange,
                          handleBlur,
                          isValid,
                          setFieldTouched,
                          setFieldValue,
                          dirty,
                      }) => renderForm({
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                        isValid,
                        dirty,
                        values: values.expenses,
                        errors: errors.expenses,
                        touched: touched.expenses
                    })}
                </Formik>
            </Modal.Body>
        </PaymentDetailsModalStyled>
    )
}
